module.exports = __webpack_public_path__ + "img/thumbnail_Wisent_f_leucistic.71ec71f9.png";